import { defineStore } from "pinia";
import api from "@/api";
import {
  ConceptsOverview,
  ConceptStudentsResponse,
} from "@/interfaces/concepts.interface";

export const useConceptsStore = defineStore({
  id: "conceptsStore",
  state: () => ({
    conceptsOverviewData: null as ConceptsOverview | null,
    conceptStudentsData: null as ConceptStudentsResponse | null,
    loader: {
      fetchConceptsOverview: false,
      fetchConceptStudents: false,
    },
  }),

  getters: {
    getConceptsOverview(): ConceptsOverview | null {
      return this.conceptsOverviewData;
    },
    getConceptStudents(): ConceptStudentsResponse | null {
      return this.conceptStudentsData;
    },
  },

  actions: {
    /**
     * Fetch the per-concept proficiency overview (bars + counter + mastery table).
     */
    async fetchConceptsOverview(payload: any) {
      this.loader.fetchConceptsOverview = true;

      try {
        const response = await api.post("/v2/data/concepts/overview", payload);
        if (response.status === 200) {
          this.conceptsOverviewData = response.data.data;
        } else {
          throw new Error("Failed to fetch concepts overview data.");
        }
      } catch (error) {
        console.error("Error fetching concepts overview data: ", error);
        this.conceptsOverviewData = null;
      } finally {
        this.loader.fetchConceptsOverview = false;
      }
    },

    /**
     * Fetch the students at a given level for a concept + the concept's
     * capabilities description (for the segment modal).
     */
    async fetchConceptStudents(payload: any) {
      this.loader.fetchConceptStudents = true;
      this.conceptStudentsData = null;

      try {
        const response = await api.post(
          "/v2/data/concepts/concept-students",
          payload
        );
        if (response.status === 200) {
          this.conceptStudentsData = response.data.data;
        } else {
          throw new Error("Failed to fetch concept students data.");
        }
      } catch (error) {
        console.error("Error fetching concept students data: ", error);
        this.conceptStudentsData = null;
      } finally {
        this.loader.fetchConceptStudents = false;
      }
    },
  },
  persist: true,
});
